/**
 * @file PlanYearCustomTextTab.js
 * @description Tab component for managing plan year text with rich text editing.
 */

import React, { useState, useEffect, useCallback, useRef } from 'react';
import RichTextEditor from '../../new-portal-page/RichTextEditor';
import styles from '../PlanYear.module.scss';
import { getText } from '../../../i18n';

const PlanYearCustomTextTab = ({ data, onChange }) => {
    const [content, setContent] = useState(data.text || '');
    const [initialContentSet, setInitialContentSet] = useState(false);
    const staticInitialContent = useRef(data.text || '').current;

    useEffect(() => {
        if (!initialContentSet) {
            setContent(data.text || '');
            setInitialContentSet(true);
        }
    }, [data.text, initialContentSet]);

    useEffect(() => {
        if (initialContentSet && content !== (data.text || '')) {
            onChange({ text: content });
        }
    }, [content, onChange, data.text, initialContentSet]);

    const handleContentUpdate = useCallback(input => {
        setContent(input);
    }, []);

    return (
        <div className="col-12 col-xs-12 col-md-12 col-lg-8 m-auto pb-5">
            <div className="form-group mb-3">
                <div className=" mb-5 pt-4">
                    <h5 className="">{getText('msg_a986383aee2a')}</h5>
                    <p className="text-muted">{getText('msg_6f30248d07e5')}</p>
                </div>
                <div className={styles.editorContainer}>
                    <RichTextEditor
                        initialContent={staticInitialContent}
                        onContentUpdate={handleContentUpdate}
                        disableHomeLink={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default PlanYearCustomTextTab;
